define(["./nodeCommandsModule"], function (nodeCommandsModule) {
    "use strict";

    return nodeCommandsModule.service("nodeCommandOptimizeRestrictions", [
        "optimizationServiceInvoker",
        "messagesModal",
        "$q",
        function (optimizationServiceInvoker, messagesModal, $q) {
            return function (trips, orders, config, restrictions) {
                if (trips && trips.length > 0 || orders && orders.length > 0) {
                    return optimizationServiceInvoker.optimize(trips, orders, config, restrictions);
                }
                return messagesModal("dialog.error", "optimization.error.empty.froms")
                    .then(function(){
                        return $q.reject();
                    });
            };
        }
    ]);
});